/**
 * IMPORTS
 */

import { changePasswordRepository } from "@/repositories/alterar-senha-usuario";

/**
 * Função que solicita recuperação de senha 🛠️.
 */
const handleChangePassword = async (token: string, senha: string, novaSenha: string) => {
  try {
    const data = await changePasswordRepository.resetPassword(token, senha, novaSenha);

    return data;
  } catch (error: any) {
    // erro do backend padronizado
    const message =
      error?.response?.data?.errors?.message ||
      error?.response?.data?.message ||
      "Erro ao alterar senha!";

    throw new Error(message);
  }
};

/**
 * EXPORTS
 */
export { handleChangePassword };
